import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4 bg-white" data-id="element-65">
      <div className="max-w-3xl mx-auto text-center" data-id="element-66">
        <ShieldCheckIcon className="w-24 h-24 text-yellow-400 mx-auto mb-6" data-id="element-67" />
        <h2 className="text-4xl md:text-5xl font-black text-black mb-8 uppercase" data-id="element-68">
          GARANTÍA DE CLARIDAD
        </h2>

        <div className="text-2xl md:text-3xl font-bold text-gray-800 space-y-4 mb-8" data-id="element-69">
          <p data-id="element-70">Probalo.</p>
          <p data-id="element-71">Aplicalo.</p>
          <p className="text-red-600" data-id="element-72">Si no te da claridad y dirección…</p>
        </div>

        <p className="text-4xl md:text-5xl font-black text-black mb-6" data-id="element-73">
          👉 no era para vos.
        </p>

        <p className="text-xl text-gray-500 font-bold uppercase tracking-widest" data-id="element-74">
          (Sencillo. Sin vueltas.)
        </p>
      </div>
    </section>;
}